var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29.5,
    cy: 29.5,
    r: 29.5,
    fill: "#8F8F8F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.7694 25.4404C33.9546 25.4404 37.3474 22.0476 37.3474 17.8624C37.3474 13.6772 33.9546 10.2844 29.7694 10.2844C25.5842 10.2844 22.1914 13.6772 22.1914 17.8624C22.1914 22.0476 25.5842 25.4404 29.7694 25.4404Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9252 39.649C44.9252 44.3568 44.9252 48.1742 29.7692 48.1742C14.6133 48.1742 14.6133 44.3568 14.6133 39.649C14.6133 34.9412 21.3994 31.1238 29.7692 31.1238C38.1391 31.1238 44.9252 34.9412 44.9252 39.649Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.55907785f11b15c809f119758c3e0338.svg";
export { ForwardRef as ReactComponent };